import { render } from "./ImagePicker.vue?vue&type=template&id=67a5cd87&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"

import "./ImagePicker.vue?vue&type=style&index=0&id=67a5cd87&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5cd87"]])

export default __exports__